// extracted by mini-css-extract-plugin
export default {"vertical":"vertical---Mx4Hm"};